import React, { Component } from 'react';
import { submit, getFormValues, reduxForm } from 'redux-form';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import AsideContentContainer from '../../components/AsideContentContainer/AsideContentContainer';
import PersonalInformationForm from './PersonalInformationForm/PersonalInformationForm';
import CTABannerContainer from '../../components/CTABannerContainer/CTABannerContainer';
import ToolTip from '../../../shared-components/ToolTip/ToolTip';
import { FormattedHTMLMessage, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import StickyContainer from '../../../shared-components/StickyContainer/StickyContainer';
import StickyBody from '../../../shared-components/StickyBody/StickyBody';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import { saveDataInSession } from '../../../framework/store/ServerData/ServerDataActions';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import { FORM_ID, FLOW_TYPE, CREDIT_TYPE } from '../../../framework/App/AppConstants';
import { APPLY_TYPE, TERMS_RESOURCES_TO_PREFETCH } from '../../USConstants';
import { PAGE_NAME } from '../../config/pageNames';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import GriffinPhone from 'griffin-paypal/lib/client/phone';
import { formatPhoneNumber } from '../../components/PhoneForm/PhoneFormUtils';
import { CONTEXT_TYPE } from '../../../framework/App/SkeletonPage/SkeletonPageConstants';
import { submitApplicationApi } from '../TermsPage/TermsPageActions';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import NotificationBanner, { NOTIFICATION_TYPE } from '../../../shared-components/NotificationBanner/NotificationBanner';
import Button, {BUTTON_STYLE} from '../../../shared-components/Button/Button';
import './PersonalInformationPage.less';
import { showPhoneOptOutCheckbox, submitForCreditAccountIdentification } from './PersonalInformationPageAction';
import { handleSubmitFail } from '../../../shared-components/FormElement/FormElementUtils';
import { getInitialFormValues } from '../../config/form';

const LOCALE_PREFIX = 'US/pages/PersonalInformationPage/PersonalInformationPage';

export class PersonalInformationPage extends Component {
    static propTypes = {
        creditType: PropTypes.string.isRequired,
        user: PropTypes.object,
        isPayInFullNowAvailable: PropTypes.bool,
        applicationType: PropTypes.string,
        formValues: PropTypes.object.isRequired,
        formattedPhone: PropTypes.string,
        isMiniBrowser: PropTypes.bool,
        incentivesDetails: PropTypes.object,
        flow: PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        submitCallback: PropTypes.func.isRequired,
        onClickContinue: PropTypes.func,
        onClickX: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        usTermsUri: PropTypes.string.isRequired,
        submitting: PropTypes.bool, // Redux inject this to indicate if the form submit is still in progress
        handleSubmit: PropTypes.func // Redux inject this function; use this to pass in the form submit handler!
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleSubmit = () => {
        const { submitCallback, formValues, applicationType } = this.props;
        return submitCallback({ ...formValues }, applicationType, PAGE_NAME.TERMS_PAGE,);
    };

    handleClickX = event => {
        this.props.onClickX(event);
    };

    handleClickContinue = () => {
        const { onClickContinue, formValues } = this.props;
        onClickContinue(formValues);
    };

    getHeader() {
        const flow = this.props.flow;
        // Passing singleColumnLayout as false as the header width will change based on aside content.
        const defaultHeader = (
            <Header
                onCancel={this.handleClickX} singleColumnLayout={false}
            />
        );

        if (flow !== FLOW_TYPE.TESLA && flow !== FLOW_TYPE.VENICE) {
            return defaultHeader;
        }
        return '';
    }

    render() {
        const {
            intl, user, onClickContinue, formattedPhone, applicationType, creditType,
            incentivesDetails, flow, usTermsUri,
            submitting, handleSubmit
        } = this.props;

        const firstName = _.get(user, 'firstName');

        const header = this.getHeader();

        const ESIGN_TERMS_URL = '/ppcreditapply/terms/esign-syf-us.html';

        let nextButtonText = <FormattedMessage id={`${LOCALE_PREFIX}.agree-review-terms`} />;
        let bmlEsignInfo;

        if (applicationType === APPLY_TYPE.FAST) {
            nextButtonText = <FormattedMessage id={`${LOCALE_PREFIX}.submit-application`} />;
        } else {
            bmlEsignInfo = (
                <div className="bmlEsignInfo">
                    <FormattedHTMLMessage
                        id={`${LOCALE_PREFIX}.bmlapply-esign-text-1`}
                    />&nbsp;
                    <PopupLink
                        url={ESIGN_TERMS_URL}
                        className="popup accessible-link"
                        name="esign-consent"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.bmlapply-esign-link-text`}
                        />
                    </PopupLink>&nbsp;
                    <FormattedMessage id={`${LOCALE_PREFIX}.bmlapply-esign-text-2`} />
                </div>
            );
        }

        //For FAST APPLY we need to add a friendly banner on the top
        const napeBanner = (
            <NotificationBanner
                id="napeMsg"
                message={intl.formatMessage({ id: `${LOCALE_PREFIX}.nape-message` }, { firstName })}
                type={NOTIFICATION_TYPE.SUCCESS}
            />
        );

        const showCtaBanner =
            (flow !== FLOW_TYPE.DIRECT_APP) &&
            (flow !== FLOW_TYPE.TESLA) &&
            (flow !== FLOW_TYPE.VENICE) &&
            (applicationType !== APPLY_TYPE.FAST);

        let ctaBanner = null;
        if (showCtaBanner) {
            ctaBanner = (
                <CTABannerContainer
                    showDefaultGreeting={true}
                />
            );
        }

        return (
            <div className="outerWrapper us-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="PersonalInformationPage">
                            {header}
                            <div id="content">
                                <div id="content-child" className="row-fluid table-layout">
                                    <div
                                        id="content-left"
                                        className={`${(flow === FLOW_TYPE.TESLA) ? 'span13' : 'span12'} table-cell`}
                                    >
                                        <StickyContainer>
                                            <StickyBody>
                                                {ctaBanner}
                                                {applicationType === APPLY_TYPE.FAST && napeBanner}
                                                <div className="body-content">
                                                    <div className="form-header">
                                                        <h1 id="personal-info-header" className="alpha has-tooltip-icon">
                                                            <FormattedMessage id={`${LOCALE_PREFIX}.header`} />
                                                            <ToolTip
                                                                id="personalInfoPageToolTip"
                                                                text={intl.formatMessage({
                                                                    id: `${LOCALE_PREFIX}.general-tooltip`
                                                                })}
                                                            />
                                                        </h1>
                                                    </div>
                                                    <PersonalInformationForm
                                                        onSubmit={handleSubmit(this.handleSubmit)}
                                                    />
                                                    {bmlEsignInfo}
                                                </div>
                                            </StickyBody>
                                            <StickyFooter fixToBottom={false} fadedBackground={true}>
                                                <div className="body-content">
                                                    <div id="action-buttons" className="buttons">
                                                        <Button
                                                            data-automation-id="continue"
                                                            btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                                            id="personalInfoContinueBtn"
                                                            onClick={this.handleClickContinue}
                                                            disabled={submitting}
                                                        >
                                                            {nextButtonText}
                                                        </Button>
                                                        <CancelUrl
                                                            componentType={COMPONENT_STYLE.LINK_BUTTON}
                                                            fptiEvent={{
                                                                stateName: 'apply_pp_credit_personalinfopage',
                                                                transitionName: 'cancel_apply_pp_credit_personalinfopage'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </StickyFooter>
                                        </StickyContainer>
                                        <div id="form-secondary-info" className="body-content">
                                            <p className="tertiary">
                                                <FormattedMessage id={`${LOCALE_PREFIX}.lender-info`} />
                                            </p>
                                        </div>
                                    </div>
                                    <aside
                                        id="content-right"
                                        className={`${(flow === FLOW_TYPE.TESLA) ? 'span11' : 'span12'} table-cell hide-for-mobile`}
                                    >
                                        <AsideContentContainer />
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer showCancelUrl={flow !== FLOW_TYPE.TESLA} />
                <link rel="prefetch" href={usTermsUri} as="document" />
                {TERMS_RESOURCES_TO_PREFETCH.map((link, index) => <link key={index} rel="prefetch" href={link.href} as={link.as} />)}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const initialValues = getInitialFormValues(state);
    const griffinPhoneHandler = GriffinPhone.createHandler(state.serverData.localityMetadata);
    const formValues = getFormValues(FORM_ID)(state) || {};
    const formattedPhone = (formValues.telephone) ? formatPhoneNumber(griffinPhoneHandler, formValues.telephone) : undefined;
    const isMiniBrowser = _.get(state, 'serverData.contextType', '') === CONTEXT_TYPE.MB_CONTEXT;
    const usTermsUri = _.get(state, 'serverData.featureFlags.usTermsUri');
    const applicationType = _.get(state, 'serverData.applyType');

    if (applicationType !== APPLY_TYPE.FAST) {
        initialValues.telephone = '';
    }

    return {
        initialValues, // redux-form will use this to initialize the UI form
        creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
        user: _.get(state, 'serverData.user'),
        isPayInFullNowAvailable: _.get(state, 'serverData.isPayInFullNowAvailable'),
        applicationType,
        formValues,
        formattedPhone,
        isMiniBrowser,
        incentivesDetails: _.get(state, 'serverData.incentivesDetails') || {},
        flow: _.get(state, 'serverData.flow'),
        usTermsUri,
    };
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'prepare_apply_pp_credit_personalinfopage'));
    },
    onClickContinue(formValues) {
        const telephone = _.get(formValues, 'telephone');
        if (!telephone) {
            dispatch(showPhoneOptOutCheckbox(true));
        }
        dispatch(submit(FORM_ID));
    },
    onClickX() {
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'cancel_x_apply_pp_credit_personalinfopage'));
    },
    submitCallback(formValues, applicationType, nextPage) {
        formValues.phoneOptOut = formValues.phoneOptOut || false;
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'process_apply_pp_credit_personalinfopage'));
        //If Asset Lite Phase 2 is on treatment_1 then click of continue on personal info page should call CIS.
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'process_CIS'));
        dispatch(spinnerOpen());
        return dispatch(submitForCreditAccountIdentification(formValues)); 
    }
});

// redux-form lives where the form `submit` is
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        onSubmitFail: handleSubmitFail,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(PersonalInformationPage)
));
